import CheckCircle from "assets/check-circle.svg";
import CartCircle from "assets/cart-circle.svg";
import DollarCircle from "assets/dollar-circle.svg";

export const INSTRUCTION_LIST = [
  {
    alt: "Check",
    icon: CheckCircle,
    text: "Check GCX before you shop to save on every purchase"
  },
  {
    alt: "Save",
    icon: CartCircle,
    text: "Get up to 30% off gift cards to use on your favorite brands"
  },
  {
    alt: "Checkout",
    icon: DollarCircle,
    text: "Combine our deals with sale prices to save more at the store"
  }
];
